<template>
    <div id="headerComponent">
        <div class="headerComponent-inner" v-bind:class="{ fixed: headerFixed }">
            <div class="header-left" v-show="!mobile_search" v-if="headerFixed">
                <div class="header-logo">
                    <a v-bind:href="$foodbookConfig.homepage"><img :src="logo" alt="Logo"></a>
                </div>
            </div>
            <!--<div class="header-center" v-if="!hideCenter">
                <div class="header-booking-info wiz-visible" ref="wzdropdown">
                    <button @click="show = !show">{{ buttonText }}</button>
                    <div class="wz-dropdown" v-show="show">
                        <ul class="wz-dropdown-nav">
                            <li v-bind:class="{'active':dateNow}" @click='setDeliveryNow'>
                                <a href="#">
                                    <div class="gird">
                                        <div class="svg-icon">
                                            <svg width="20" height="20" viewBox="0 0 20 20"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <circle fill="none" stroke="#000" stroke-width="1.1" cx="10" cy="10"
                                                        r="9"></circle>
                                                <rect x="9" y="4" width="1" height="7"></rect>
                                                <path fill="none" stroke="#000" stroke-width="1.1"
                                                      d="M13.018,14.197 L9.445,10.625"></path>
                                            </svg>
                                        </div>
                                        <div class="text"><span>Delivery Now</span></div>
                                        <div class="svg-icon check" v-if="dateNow">
                                            <svg width="20" height="20" viewBox="0 0 20 20"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <polyline fill="none" stroke="#000" stroke-width="1.1"
                                                          points="4,10 8,15 17,4"></polyline>
                                            </svg>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li @click='isOpen = true' v-bind:class="{'active':customDate}">
                                <div class="gird">
                                    <div class="svg-icon">
                                        <svg width="20" height="20" viewBox="0 0 20 20"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M 2,3 2,17 18,17 18,3 2,3 Z M 17,16 3,16 3,8 17,8 17,16 Z M 17,7 3,7 3,4 17,4 17,7 Z"></path>
                                            <rect width="1" height="3" x="6" y="2"></rect>
                                            <rect width="1" height="3" x="13" y="2"></rect>
                                        </svg>
                                    </div>
                                    <div class="text"><span>Time Order</span></div>
                                    <div class="svg-icon check" v-if="customDate">
                                        <svg width="20" height="20" viewBox="0 0 20 20"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <polyline fill="none" stroke="#000" stroke-width="1.1"
                                                      points="4,10 8,15 17,4"></polyline>
                                        </svg>
                                    </div>
                                </div>
                            </li>
                            <li v-if="isOpen" class="child">
                                <div class="booking-selected">
                                    <div class="set-date">
                                        <label for="selectDate">Set date </label>
                                        <select id="selectDate" v-model="booking_info.Book_Date">
                                            <option :value="date.value" :key="index"
                                                    v-for="(date,index) in dateDelivery">{{date.name}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="set-time">
                                        <label for="selectTime">Set time</label>
                                        <select id="selectTime" v-model="booking_info.Note">
                                            <option value="">Delivery Now</option>
                                            <option :value="time.value" :key="index"
                                                    v-for="(time,index) in timeDelivery">{{time.name}}
                                            </option>
                                        </select>
                                    </div>
                                    <button @click="bookingInfo">Confirm</button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="header-logaddress wiz-visible">
                    <form>
                        <div class="form-group">
                            <i class="fa fa-map-marker" aria-hidden="true"></i>
                            <gmap-autocomplete
                                    ref="mapRef"
                                    id="searchLoction"
                                    @place_changed="setPlace"
                                    placeholder="Enter shipping address"
                                    :value="cart.to_address"
                                    :options="{
                                        componentRestrictions:{
                                            country:['vn']
                                        },
                                        strictBounds:true
                                    }"
                            &gt;
                            </gmap-autocomplete>
                        </div>
                    </form>
                </div>
            </div>-->
            <div class="header-right" v-show="!mobile_search">
                <div class="search-icon wiz-hidden" @click="mobile_search = !mobile_search" v-if="visibleSearch">
                    <a href="#">
                        <svg width="28" height="28" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <circle fill="none" stroke="#000" stroke-width="1.1" cx="9" cy="9" r="7"></circle>
                            <path fill="none" stroke="#000" stroke-width="1.1" d="M14,14 L18,18 L14,14 Z"></path>
                        </svg>
                    </a>
                </div>
                <div class="header-login" ref="wzlogin">
                    <a v-bind:href="$foodbookConfig.loginpage" class="btn-login" v-if="!$foodbookConfig.userId">Log
                        in</a>
                    <div class="login-success" @click="show2 = !show2" v-if="$foodbookConfig.userId">
                        <img class="account-image" alt="Account" src="../assets/images/default-user.png">
                        <span class="account-name">YOUR PROFILE</span>
                        <div class="wz-dropdown" v-show="show2">
                            <ul class="wz-dropdown-nav">
                                <li><a :href="$foodbookConfig.customerpage">Your Profile</a></li>
                                <li><a href="#" @click.prevent="logoutAccount">Logout</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="header-cart wiz-visible" v-if="!hideCart">
                    <a href="#" v-on:click="gotoCheckout">
                        <span class="count">{{cart | countTotalItems}}</span>
                        <span class="icon"><img src="../assets/images/cart.png" alt="Cart"></span>
                    </a>
                </div>
            </div>
            <div class="header-search" v-if="mobile_search">
                <form class="search-area">
                    <input type="text" placeholder="Search Product" autocomplete="off"
                           v-on:input="$emit('updatesearch', $event.target.value)">
                </form>
                <a href="#" class="mobile_search_close" @click="closeSearch">
                    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                        <line fill="none" stroke="#000" stroke-width="1.1" x1="1" y1="1" x2="13" y2="13"></line>
                        <line fill="none" stroke="#000" stroke-width="1.1" x1="13" y1="1" x2="1" y2="13"></line>
                    </svg>
                </a>
            </div>
        </div>
        <div class="sticky-placeholder" v-bind:style="{ height: '60px', margin: '0px' }" v-if="headerFixed"></div>
    </div>
</template>

<script>
    export default {
        name: 'Header',
        props: ['hideCenter', 'hideCart', 'visibleSearch','headerFixed'],
        data() {
            let $today = new Date();
            let dateY = $today.getFullYear();
            let dateM = $today.getMonth() + 1;
            let dateD = $today.getDate();
            if (dateM < 10) dateM = '0' + dateM;
            if (dateD < 10) dateD = '0' + dateD;
            let dateVal = dateY + '-' + dateM + '-' + dateD + ' 00:00:00';

            return {
                dateNow: this.$cart.booking_info ? false : true,
                customDate: this.$cart.booking_info ? true : false,
                show: false,
                show2: false,
                isOpen: false,
                mobile_search: false,
                cart: this.$cart,
                booking_info: this.$cart.booking_info || {
                    Book_Date: dateVal,
                    Hour: null,
                    Minute: null,
                    Number_People: -1,
                    Note: ""
                },
                buttonText: "DELIVERY NOW",
                logo:this.$foodbookConfig.logo,
            };
        },
        created() {
            window.addEventListener('click', this.close)
            if (this.dateNow) {
                this.buttonText = "DELIVERY NOW";
            } else {
                let $date = new Date(this.booking_info.Book_Date);
                this.buttonText = $date.getDate() + '/' + ($date.getMonth() + 1) + '/' + $date.getFullYear() + ' ' + this.booking_info.Note;
            }
        },
        beforeDestroy() {
            window.removeEventListener('click', this.close)
        },
        mounted() {
            if (this.$refs.mapRef) {
                this.$gmapApiPromiseLazy().then(() => {
                    var geolocation = {
                        lat: 10.780833,
                        lng: 106.756944
                    };
                    var circle = new google.maps.Circle({
                        center: geolocation,
                        radius: 3000
                    });
                    this.$refs.mapRef.$autocomplete.setBounds(circle.getBounds());
                });
            }
        },
        methods: {
            close(e) {
                if (!this.$refs.wzlogin.contains(e.target)) {
                    this.show2 = false;
                }
            },
            setPlace(place) {
                if (place.geometry) {
                    this.cart.to_address = place.formatted_address;
                    this.cart.longitude = place.geometry.location.lng();
                    this.cart.latitude = place.geometry.location.lat();
                    sessionStorage.cart = JSON.stringify(this.cart);
                }
            },
            closeSearch() {
                this.mobile_search = !this.mobile_search;
                this.$emit('updatesearch', '');
            },
            logoutAccount() {
                window.location.replace(this.$foodbookConfig.wpapi + '/logout');
            },
            updateSessionCart() {
                sessionStorage.cart = JSON.stringify(this.cart);
            },
            gotoCheckout() {
                if (!this.cart.ordersItem.length) {
                    this.$toasted.show("Please select the product you want to buy", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                } else {
                    window.location.replace(this.$foodbookConfig.checkoutpage);
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue